import { on } from 'delegated-events'

const fn = {
    init: () => {
        on('click', '.toggle-list', fn.handleToggle)
    },

    handleToggle: (e) => {
        e.preventDefault()
        var target = e.target
        var button = target.closest('button')
        var listType = button.getAttribute('data-type')

        if (listType == 'List') {

            var grids = document.querySelectorAll('.project-grid-card-item')
            var lists = document.querySelectorAll('.project-grid-list-item')

            grids.forEach((el) => {
                el.classList.add('hidden')
            })
            lists.forEach((el) => {
                el.classList.remove('hidden')
            })

            var grid = document.getElementById('gridView')
            grid.classList.add('opacity-40')
            grid.classList.remove('opacity-100')

            var list = document.getElementById('listView')
            list.classList.add('opacity-100')
            list.classList.remove('opacity-40')

        }
        else {

            var grids = document.querySelectorAll('.project-grid-card-item')
            var lists = document.querySelectorAll('.project-grid-list-item')

            grids.forEach((el) => {
                el.classList.remove('hidden')
            })
            lists.forEach((el) => {
                el.classList.add('hidden')
            })

            var grid = document.getElementById('gridView')
            grid.classList.add('opacity-100')
            grid.classList.remove('opacity-40')

            var list = document.getElementById('listView')
            list.classList.add('opacity-40')
            list.classList.remove('opacity-100')

        }

    }

}

export default {
    can: () => document.querySelector('.pagetype-projectpage') || document.querySelector('.pagetype-departmentprojectspage'),
    run: fn.init,
}
